import ManageAdmin from "./ManageAdmin";
export default ManageAdmin;